import React from 'react';
import { Modal, Button, Comment } from 'semantic-ui-react';

const Messages = (props) => {
  if (!props.banners || props.banners.length === 0) {
    return <span></span>;
  }

  return (
    <Modal
      closeIcon
      closeOnDimmerClick={false}
      onClose={() => {
        props.handleBannersAcknowledged();
      }}
      open={true}
      style={{ width: '500px' }}
    >
      <Modal.Header>Hi there</Modal.Header>
      <Modal.Content scrolling>
        {props.banners &&
          props.banners.length > 0 &&
          props.banners.map((banner) => (
            <Comment
              key={banner.xpas_banner_id}
              style={{ paddingBottom: '20px' }}
            >
              <Comment.Content>
                <Comment.Author as='b'>{banner.category}</Comment.Author>
                <Comment.Text>{banner.message}</Comment.Text>
              </Comment.Content>
            </Comment>
          ))}
      </Modal.Content>

      <Modal.Actions>
        <Button
          onClick={() => props.handleBannersAcknowledged()}
          primary
          fluid
          style={{ marginLeft: '-1px' }}
        >
          OK
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default Messages;
